import ViewControlCard from "./ViewControlCard";

export default ViewControlCard;
